import React from 'react';

interface TaskBoardTaskItemStatusProps {
    status: string;
}
export const TaskBoardTaskItemStatus: React.FC<TaskBoardTaskItemStatusProps> = ({ status }) => {
    return (
        <span
            style={{
                backgroundColor: '#f0f0f0',
                fontSize: 10,
                height: 15,
                padding: '0 7px',
                borderRadius: 4,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
        >
            {status}
        </span>
    );
};
